/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Alert, Modal } from 'antd';
import { QrReader } from 'react-qr-reader';

interface Props {
  onError?: (error: string) => void;
  onScan: (data: string | null) => void;
  showCamera: boolean;
  setShowCamera: (showCamera: boolean) => void;
  cameraStyle?: React.CSSProperties;
}

const QRScanner = ({
  cameraStyle,
  onError = () => {},
  onScan,
  setShowCamera,
  showCamera,
}: Props) => {
  const [cameraError, setCameraError] = useState<string | null>(null);
  return (
    <Modal
      open={showCamera}
      onCancel={() => setShowCamera(false)}
      afterClose={() => setCameraError(null)}
      destroyOnClose
      footer={null}
    >
      {cameraError && (
        <Alert
          type="error"
          showIcon
          message="No se pudo abrir la cámara"
          description={`${cameraError}. Revisá el permiso de cámara del navegador; fuera de https o localhost el navegador no la habilita.`}
          style={{ marginBottom: 12 }}
        />
      )}
      <div
        style={{
          flex: '1',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <QrReader
          constraints={{
            facingMode: 'environment',
            width: { ideal: 1920 },
            height: { ideal: 1080 },
          }}
          scanDelay={500}
          containerStyle={cameraStyle}
          onResult={(result, error) => {
            if (!!result) {
              onScan(result.getText());
            }

            if (!!error) {
              onError(error.message);
              if (typeof (error as any).getKind !== 'function') {
                setCameraError(error.message);
              }
            }
          }}
        />
      </div>
    </Modal>
  );
};

QRScanner.defaultProps = {
  cameraStyle: {
    height: '40%',
    width: '80%',
  },
  onLoad: () => {},
  onError: () => {},
};

export default QRScanner;
